import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import useScreenType from "components/ProjectNonSpecificComponents/Hooks/useScreenType"
import { IRequestTableFormField } from "components/ProjectSpecificComponents/Interfaces/FormsInterface"
import { isReactSelectSingleOption } from "components/ProjectSpecificComponents/Interfaces/ExternalComponentsInterfaces"
import React from "react"
import { useTranslation } from "react-i18next"
import PreferencesCheckbox from "../../Global/atoms/PreferencesCheckbox"
import MainFieldSelect from "../atoms/MainFieldSelect"
import FormField from "./FormField"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"

interface Props {
	value: IRequestTableFormField
	onChangeFormData: (data: Partial<IRequestTableFormField>) => void
}

const TableColumnProperties = ({
	value: { mainFieldKey, searchable, sortable },
	onChangeFormData = () => {},
}: Props) => {
	const { isMobile } = useScreenType()
	const { t } = useTranslation()
	const formStore = useFormStore()

	const getFieldType = (mainFieldKey: string) => {
		var type: string = ""
		try {
			formStore.mainFieldsData?.forEach(
				({ fieldType, fieldId }) => fieldId === mainFieldKey && (type = fieldType)
			)
		} catch (err) {}
		return type
	}
	return (
		<HyperDiv
			direction={isMobile ? "column" : "row"}
			padding="0 1rem"
			id="table-colum-property-section"
		>
			<HyperDiv height="100%" width={isMobile ? undefined : 250}>
				<FormField
					label={t(`forms.field-label.field`)}
					placeholderValue=""
					editable
					direction={isMobile ? "Horizontal" : "Vertical"}
				>
					<MainFieldSelect
						valueKey={mainFieldKey}
						onChange={(selectedOption) => {
							onChangeFormData(
								isReactSelectSingleOption(selectedOption)
									? {
											mainFieldKey: selectedOption.value,
											mainFieldLabel: selectedOption.label,
											type: getFieldType(selectedOption.value),
									  }
									: {
											mainFieldKey: undefined,
											mainFieldLabel: undefined,
									  }
							)
						}}
						type={"requestTable"}
					/>
				</FormField>
			</HyperDiv>

			<Whitespace x="3" h />

			<HyperDiv className="fill-cter" width={isMobile ? undefined : 300}>
				<FormField
					label={t(`table.tooltip-search`)}
					placeholderValue=""
					editable
					direction={isMobile ? "Horizontal" : "Vertical"}
				>
					<PreferencesCheckbox
						checked={searchable}
						onCheck={(checked) => onChangeFormData({ searchable: checked })}
					/>
				</FormField>
			</HyperDiv>

			<HyperDiv className="fill-cter" width={isMobile ? undefined : 300}>
				<FormField
					label={t(`table.tooltip-sort`)}
					placeholderValue=""
					editable
					direction={isMobile ? "Horizontal" : "Vertical"}
				>
					<PreferencesCheckbox
						checked={sortable}
						onCheck={(checked) => onChangeFormData({ sortable: checked })}
					/>
				</FormField>
			</HyperDiv>
			<Whitespace h x="2" />
		</HyperDiv>
	)
}

export default TableColumnProperties
